module.exports = __webpack_public_path__ + "img/svg/background-mobile.14993d1f29abd8eeda722f400e90ecb5.svg";